import { useAuthContext } from "../context/AuthContext";
import IRoute from "../models/route.interface";
import { ILink } from "../models/users.interface";
import { mainRoutes } from "../routes/main-routes";
import {
  filterRoutesByUser,
  getDefaultRedirectByUserRole,
} from "../utils/routes.util";
import useScopedRoutes from "./useScopedRoutes";

export function useMainRoutes() {
  const {
    state: { user },
  } = useAuthContext();

  const {
    routes,
    defaultRedirectUrl: defaultScopedRedirectUrl,
  } = useScopedRoutes(mainRoutes);

  const filteredRoutes: IRoute[] = !user
    ? []
    : filterRoutesByUser(
        routes,
        user.role,
        user.organization?.type,
        user.permissions
      );

  const links: ILink[] = filteredRoutes
    .filter((route) => route.link)
    .map((route) => ({
      id: route.id,
      to: route.path as string,
      icon: route.link!.icon as string,
      label: route.link!.text,
    }));

  return {
    mainRoutes: filteredRoutes,
    links,
    defaultRedirectUrl:
      defaultScopedRedirectUrl ??
      getDefaultRedirectByUserRole(user?.role, user?.permissions),
  };
}
